import { isUberEatsOrder } from '../../utils/emailReceipt/receiptDeliveryConfig';

export type PrintedFormImpr = 'PAP' | 'ELE' | 'PEL';

/**
 * Print format sent to WEB-SRM for a printable bill, from the receipt choice on that bill.
 * Uber Eats stays on paper. A closing reprint without a choice stays on paper.
 */
export function resolveFormImpr(order: any, context: { modImpr?: string; billType?: string } = {}): PrintedFormImpr {
  if (isUberEatsOrder(order)) return 'PAP';
  const explicit = order?.receiptDelivery === 'paper'
    || order?.receiptDelivery === 'email'
    || order?.receiptDelivery === 'both';
  if (context.modImpr === 'RPR' && context.billType !== 'temporary' && !explicit) return 'PAP';
  const hasRecipient = typeof order?.receiptEmail === 'string' && order.receiptEmail.includes('@');
  if (!hasRecipient) return 'PAP';
  if (order?.receiptDelivery === 'email') return 'ELE';
  if (order?.receiptDelivery === 'both') return 'PEL';
  return 'PAP';
}

/** Y digit of CASESSAI "XXX.YZZ" used by the SW-77-V certification cases. */
export function formImprFromCasEssai(casEssai: string | undefined | null): PrintedFormImpr | null {
  const match = /^\d{3}\.(\d)\d{2}$/.exec(String(casEssai || '').trim());
  if (!match) return null;
  switch (match[1]) {
    case '1': return 'PAP';
    case '2': return 'ELE';
    case '4': return 'PEL';
    default: return null;
  }
}
